// splide.js
const options = {
  arrows: false,
  cover: true,
  // heightRatio: 0.5,
  perMove: 1,
  gap: "2vw",
  updateOnMove: true,
  padding: "25vw",
  type: "loop",
  focus: "center",
  breakpoints: {
    767: {
      perPage: 1,
      // gap: 0,
      padding: "1.5rem",
      heightRatio: 0,
    }
  },
  classes: {
    // ページネーション関連のクラスを追加したい場合
    pagination: "splide__pagination your-class-pagination", // コンテナ要素
    page: "splide__pagination__page your-class-page", // ページネーションのボタン要素
  },
};
const itemoptions = {
  arrows: true,
  cover: true,
  perPage: 4,
  // heightRatio: 0.5,
  perMove: 1,
  gap: 0,
  updateOnMove: true,
  padding: 0,
  type: "loop",
  // focus: "center",
  breakpoints: {
    767: {
      perPage: 2,
    }
  }
};

if (document.querySelector('.splide_fv')) {
    const splidefv = new Splide(".splide_fv", options).mount();
  }
if (document.querySelector('.splide_items')) {
    const splideitems = new Splide(".splide_items", itemoptions).mount();
  }

// updateOptionsForSmallScreen();
// window.addEventListener("resize", updateOptionsForSmallScreen);






// メガメニュー
const megaMenuDetails = document.querySelectorAll('details[id^="Details-HeaderMenu-"]');

document.body.addEventListener('click', (event) => {
  const targetElement = event.target;

  if (isDetailsButton(targetElement)) {
    toggleMegaMenu(targetElement);
  } else {
    closeAllMegaMenus();
  }
});

function isDetailsButton(element) {
  return element.tagName === 'DETAILS' && element.id.startsWith('Details-HeaderMenu-');
}

function toggleMegaMenu(clickedButton) {
  for (const details of megaMenuDetails) {
    const isOpen = details === clickedButton && details.hasAttribute('open');

    details.removeAttribute('open');
    if (!isOpen) {
      details.setAttribute('open', '');
    }
  }
}

function closeAllMegaMenus() {
  for (const details of megaMenuDetails) {
    details.removeAttribute('open');
  }
}
